<template>
	<div class="training-agreement">
		<div class="training-agreement__container container">
			<div
				class="agreement-head training-main-name main-title"
				v-html="page.title"
        style="margin-bottom: 1rem"
			></div>

      <div v-if="items.length > 0">
        <div v-for="(item,idx) in items" :key="idx" style="margin-bottom: 2rem">
          <div v-if="item.type === 'header'">
            <h4 v-html="item.text"></h4>
          </div>

          <div v-if="item.type === 'html'" ref="htmlContainer" :data-id="item.id" @click="handleLinkClick($event)" style="color: #0071ba !important;text-decoration: underline !important;">
          </div>

          <div v-if="item.type === 'bullet'">
            <ul>
              <li v-html="item.text"></li>
            </ul>
          </div>

        </div>
      </div>

      <div v-if="currentDefinitions.length > 0">
        <h3 v-if="currentDefinitions">Definitions:</h3>

        <div v-for="(def,idx) in currentDefinitions" :key="idx" style="margin-bottom: 2rem">
          <span style="font-weight: 700">{{ def.term }}</span> - <span v-html="def.definition"></span>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
  import LS from "@/plugin/localstorage";

	export default {
    created () {
      this.defs = Object.values(LS.get("definitions"));
    },

    mounted() {
      this.$emit("agreedWithAction")
      this.$emit("submit")

      if (this.page.docJobDefinitions && this.defs) {
        const defsIds = this.page.docJobDefinitions.map(item => item.definition.id)

        this.currentDefinitions = this.defs.filter(obj => defsIds.includes(obj.id));
      }

      if (this.page.items) {
        this.items = this.page.items
      }

      this.processHtmlElements();
    },

    updated() {
      this.processHtmlElements();
    },

    data() {
			return {
        currentDefinitions: [],
        items: [],
			};
		},

		props: {
			page: Object,
			trainingAction: Object,
			transformDate: Function,
		},

    methods: {
      handleLinkClick(event) {
        event.preventDefault();

        const link = event.currentTarget.querySelector("a");
        const href = link.getAttribute('href');

        if (href && href.startsWith('http')) {
          window.open(href, '_blank', 'noopener,noreferrer');
        }
      },

      processHtmlElements() {
        const containers = this.$refs.htmlContainer;
        if (!containers) return;

        const containerArray = Array.isArray(containers) ? containers : [containers];

        containerArray.forEach(container => {
          if (!container) return;

          const itemId = container.dataset.id;
          const item = this.items.find(i => i.id.toString() === itemId);

          if (item && item.type === 'html') {
            this.createDynamicHtml(container, item.text);
          }

          document.querySelectorAll('a')
        });
      },

      createDynamicHtml(container, html) {
        container.innerHTML = '';

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        Array.from(tempDiv.childNodes).forEach(node => {
          const clonedNode = node.cloneNode(true);

          container.appendChild(clonedNode);
        });
      }
    },
	};
</script>
<style lang="scss"></style>
